// @ts-nocheck
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useMemo, useState } from "react";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import WestIcon from "@mui/icons-material/West";
import { phoneNumberFormat } from "../../../utils/methods/formatters";
import theme from "../../../theme";
import { ExpandMore } from "@mui/icons-material";
import {
  CustomButton,
  SecondaryButton,
} from "../../../components/Custom/CustomButton";
import { useEffect } from "react";
import { apiRequest } from "../../../services/apiService";
import { useDispatch } from "react-redux";
import { alertDialogAciton } from "../../../store/actions/auth";
import {
  convertFromUTCToGivenTimezone,
  formatAMPM,
} from "../../../utils/methods/dateAndTimeMethods";
import { useSelector } from "react-redux";
import {
  applyMultipleOpportunityAction,
  applyOpportunityAction,
  clearContractorAppliedListAction,
  declineOpportunityAnywayAction,
  declineOpportunityMultipleAction,
  updateMultipleResponseAnyway,
  updateResponseAnyway,
} from "../../../store/actions/opportunities";
import { clearScheduleDataAction } from "../../../store/actions/contractorScheduleTabActions";
import { generateHtmlTable } from "../../event-request-details/components/SendOpportunities";
import { dateRegex } from "../../../utils/constants/dateRegex";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { AlertDialogForSendOpportunity } from "../../../components/Custom/AlertDialog";
import { generateDateTableForDecline } from "../components/ViewOpportunitiesModal";
import { CustomSwitch } from "../../../components/Custom/Switch";
import OpportunityContainer from "../../event-request-details/components/OpportunityContainer";

export default function ViewMultipleOpportunityModal({
  open,
  handleClose,
  showButtons,
  rowData,
  setCount,
}) {
  const initialAlertData = useMemo(
    () => ({
      status: false,
      message: null,
      title: null,
      onOk: null,
      okLabel: null,
      isLoading: false,
    }),
    [],
  );

  const isMediumScreen = useMediaQuery("(max-width: 970px)");
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [isLoading, setIsLoading] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const [showBtns, setShowButtons] = useState(false);
  const [allNR, setAllNR] = useState(false);
  const [positions, setPositions] = useState(null);
  const [alertData, setAlertData] = useState(initialAlertData);
  const { userId } = useSelector((state) => state?.auth);
  const { oppLoading: loading } = useSelector((state) => state.opportunities);

  const dispatch = useDispatch();

  const handleAccChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  async function fetchData() {
    setIsLoading(true);
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getMulPendingAppliedOpportunities`,
      // url: `getMulOpportunities`,
      data: null,
      isToken: true,
      params: {
        sessionId: rowData?.sessionId,
        eventId: rowData?.eventId,
      },
    });
    if (response?.status === 200) {
      setPositions(response?.data?.data);
      let sb = false;
      let anr = true;
      response?.data?.data?.forEach((item) => {
        const cont = item?.contractors?.find(
          (con) => con?.contractorId === userId,
        );
        if (cont?.response?.pending) {
          sb = true;
        }
        if (!cont?.response?.pending) {
          anr = false;
        }
      });
      setShowButtons(sb);
      setAllNR(anr);
    } else if (response?.status !== 200 || error) {
      setPositions(null);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Fail to get opportunity!",
        }),
      );
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleAcceptClick = (opportunityId, positionId) => {
    setIsLoading(true);
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "applied",
          },
          params: {
            positionId: positionId,
            sessionId: rowData?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: (rdata) => {
          if (!rdata?.scheduledConflictContractors?.length) {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity accepted successfully!",
                open: true,
              }),
            );
            dispatch(clearContractorAppliedListAction());
            dispatch(clearScheduleDataAction());
            fetchData();
            setCount((prev) => prev + 1);
          } else {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Conflict Alert",
                message: "You have a schedule conflict with this opportunity!",
                onOk: () => {
                  dispatch(
                    updateResponseAnyway({
                      payload: {
                        data: {
                          response: "applied",
                        },
                        params: {
                          positionId: positionId,
                          sessionId: rowData?.sessionId,
                          Id: opportunityId,
                        },
                      },
                      successCallback: () => {
                        dispatch(
                          alertDialogAciton({
                            title: "Success",
                            message: "Opportunity accepted successfully!",
                            open: true,
                          }),
                        );
                        dispatch(clearContractorAppliedListAction());
                        dispatch(clearScheduleDataAction());
                        fetchData();
                        setCount((prev) => prev + 1);
                      },
                      failureCallback: (msg) => {
                        dispatch(
                          alertDialogAciton({
                            title: "Error",
                            message: msg || "Fail to accept opportunity!",
                            open: true,
                          }),
                        );
                      },
                    }),
                  );
                },
                okLabel: "Accept Anyway",
              }),
            );
          }
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: msg?.message || "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleAcceptMultipleOppClick = () => {
    function acceptAnywayFunc() {
      dispatch(
        updateMultipleResponseAnyway({
          payload: {
            data: {
              response: "applied",
            },
            params: {
              eventId: rowData?.eventId,
              sessionId: rowData?.sessionId,
            },
          },
          successCallback: (rdata) => {
            const html = generateHtmlTable(rdata?.warnings?.contractors);
            if (rdata?.warnings?.contractors) {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Work Hour Limit Exceeded",
                  message: `${rdata?.warnings?.message} <br />${html}`,
                }),
              );
            } else {
              dispatch(
                alertDialogAciton({
                  title: "Success",
                  message:
                    rdata?.message ?? "Opportunity accepted successfully!",
                  open: true,
                }),
              );
            }
            dispatch(clearContractorAppliedListAction());
            dispatch(clearScheduleDataAction());
            // fetchData();
            setCount((prev) => prev + 1);
            handleClose();
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                title: "Error",
                message: msg || "Fail to accept opportunity!",
                open: true,
              }),
            );
          },
        }),
      );
    }

    dispatch(
      applyMultipleOpportunityAction({
        payload: {
          data: {
            response: "applied",
          },
          params: {
            eventId: rowData?.eventId,
            sessionId: rowData?.sessionId,
          },
        },
        successCallback: (rdata) => {
          if (!rdata?.scheduledConflictContractors && !rdata?.warnings) {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: rdata?.message ?? "Opportunity accepted successfully!",
              }),
            );
          } else if (rdata?.scheduledConflictContractors || rdata?.warning) {
            let haveOnlyWarning = true;
            if (rdata?.scheduledConflictContractors) {
              haveOnlyWarning = false;
            }

            setAlertData({
              status: true,
              title: "Warning",
              message: (
                <Box>
                  {rdata?.scheduledConflictContractors && (
                    <OpportunityContainer
                      messageStr={rdata?.scheduledConflictContractors?.message}
                      title={"Scheduling Conflict Detected"}
                      contractorsList={rdata?.scheduledConflictContractors?.contractors?.map(
                        (item) => {
                          // eslint-disable-next-line
                          const { assignedRoles, ...rest } = item;
                          return rest;
                        },
                      )}
                    />
                  )}
                  {rdata?.warnings && (
                    <OpportunityContainer
                      messageStr={rdata?.warnings?.message}
                      title={"Work Hour Limit Exceeded"}
                      contractorsList={rdata?.warnings?.contractors}
                    />
                  )}
                </Box>
              ),
              okLabel: haveOnlyWarning ? null : "Accept Anyway",
              onOk: haveOnlyWarning
                ? null
                : () => {
                    acceptAnywayFunc();
                  },
            });
          }

          // NOTE: not from here
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: msg?.message || "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleDeclineClick = (opportunityId, positionId) => {
    // setIsLoading(true);
    dispatch(
      applyOpportunityAction({
        payload: {
          data: {
            response: "declined",
          },
          params: {
            positionId: positionId,
            sessionId: rowData?.sessionId,
            Id: opportunityId,
          },
        },
        successCallback: (d) => {
          let checkBoxStatus = false;
          if (d?.lastOpportunity) {
            setAlertData({
              status: true,
              message: (
                <Box>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: generateDateTableForDecline(d?.lastOpportunity),
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <CustomSwitch
                      onChange={(e) => (checkBoxStatus = e?.target?.checked)}
                    />
                    <Typography>
                      Apply hold down shift for above date
                    </Typography>
                  </Box>
                </Box>
              ),
              title: "Alert",
              onOk: () => {
                // NOTE: decline anyway
                handleDeclineAnyWayClick([
                  {
                    sessionId: rowData?.sessionId,
                    id: positionId,
                    holdDown: checkBoxStatus,
                  },
                ]);
              },
              okLabel: "Proceed",
              isLoading: false,
            });
          } else {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity denied successfully!",
                open: true,
              }),
            );
            fetchData();
            setCount((prev) => prev + 1);
          }
        },
        failureCallback: () => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleMultipleOppDeclineClick = () => {
    const list = positions
      ?.filter((item) => item?.contractors?.[0]?.response?.pending === true)
      ?.map((item) => {
        return {
          sessionId: rowData?.sessionId,
          id: item?.positionId,
        };
      });
    dispatch(
      declineOpportunityMultipleAction({
        payload: {
          data: {
            positionIds: list,
          },
          params: {
            eventId: rowData?.eventId,
          },
        },
        successCallback: (d) => {
          let checkBoxStatus = false;
          if (d?.lastOpportunityWarning) {
            setAlertData({
              status: true,
              message: (
                <Box>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: generateDateTableForDecline(
                        d?.lastOpportunityWarning,
                      ),
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {/* <Checkbox */}
                    {/*   sx={{ */}
                    {/*     padding: 0, */}
                    {/*     color: "white", */}
                    {/*   }} */}
                    {/*   onChange={(e) => (checkBoxStatus = e?.target?.checked)} */}
                    {/* /> */}
                    <CustomSwitch
                      onChange={(e) => (checkBoxStatus = e?.target?.checked)}
                    />
                    <Typography>
                      Apply hold down shift for above date
                    </Typography>
                  </Box>
                </Box>
              ),
              title: "Alert",
              onOk: () => {
                const newList = d?.lastOpportunityWarning?.map((item) => {
                  return {
                    sessionId: item?.sessionId,
                    id: item?.positionId,
                    holdDown: checkBoxStatus,
                  };
                });
                handleDeclineAnyWayClick(newList);
              },
              okLabel: "Proceed",
              isLoading: false,
            });
          } else {
            dispatch(
              alertDialogAciton({
                title: "Success",
                message: "Opportunity denied successfully!",
                open: true,
              }),
            );
            // fetchData();
            setCount((prev) => prev + 1);
            handleClose();
          }
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              title: "Error",
              message: msg || "Fail to accept opportunity!",
              open: true,
            }),
          );
        },
      }),
    );
  };

  const handleDeclineAnyWayClick = (payload) => {
    setAlertData((prev) => ({ ...prev, isLoading: true }));

    function stopLoadin() {
      setAlertData(initialAlertData);
    }
    dispatch(
      declineOpportunityAnywayAction({
        payload: {
          params: {
            eventId: rowData?.eventId,
          },
          data: { positionIds: payload },
        },
        successCallback: (d) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Success",
              message: d?.message ?? "Opportunity successfully declined",
            }),
          );
          fetchData();
          setCount((prev) => prev + 1);
          stopLoadin();
        },
        failureCallback: (msg) => {
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Failure",
              message: msg ?? "Fail to decline opportunity",
            }),
          );
          stopLoadin();
        },
      }),
    );
  };

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "#4D4D4D";
      case "not responded":
        return "#4D4D4D";
      case "applied":
        return "#02493E";
      case "declined":
        return "#371414";

      default:
        return "white";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      case "not responded":
        return "white";
      case "applied":
        return "#07EEC5";
      case "declined":
        return "#FF4B4B";

      default:
        return "black";
    }
  };

  const getContractorStatus = (arr) => {
    let result = "";
    arr?.forEach((con) => {
      if (con?.contractorId === userId) {
        if (con?.response?.applied) {
          result = "Applied";
        } else if (con?.response?.declined) {
          result = "Declined";
        } else if (con?.response?.pending) {
          result = "Not Responded";
        } else {
          result = "Draft";
        }
      }
    });
    return result;
  };

  return (
    <Modal
      // className="modelBox"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          width: isMediumScreen ? "95%" : "60%",
          minHeight: isLoading ? "60%" : "50%",
          height: "auto",
          maxHeight: "95%",
          boxShadow: 24,
          p: 4,
          borderRadius: "16px",
          maxWidth: "1080px",
          padding: "40px",
          gap: "30px",
          border: "2px solid #D175B6",
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          zIndex: 9,
          overflowY: "auto",
          "@media (max-width: 600px)": {
            minWidth: "0px",
            width: "97vw",
            maxHeight: "95vh",
            overflowY: "auto",
            maxWidth: "90vw",
          },
        }}
        className="custom-scroll-design"
      >
        {isLoading || loading ? (
          <LoadingOverlay open={isLoading || loading} />
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Button
                onClick={() => handleClose()}
                sx={{
                  minWidth: "0",
                  height: "auto",
                  background: "none",
                  padding: isSmallScreen ? "0" : "0.5rem",
                  boxShadow: "none",
                  border: isSmallScreen
                    ? "none"
                    : `1px solid ${getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      })}`,
                  zIndex: "10",
                  borderRadius: "50%",
                  cursor: "pointer !important",
                  "&:hover": {
                    minWidth: "0",
                    background: "none",
                    padding: isSmallScreen ? "0" : "0.5rem",
                    boxShadow: "none",
                    border: isSmallScreen
                      ? "none"
                      : `1px solid ${getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        })}`,
                    borderRadius: "50%",
                  },
                }}
              >
                <WestIcon />
              </Button>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                marginBottom="20px"
                sx={{
                  float: "left",
                  margin: "0 auto",
                  fontSize: "32px",
                  zIndex: "10",
                }}
              >
                View Opportunities
              </Typography>
            </Box>
            {!isLoading ? (
              <>
                <Box sx={{ width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isSmallScreen ? "column" : "row",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: "2.5rem",
                      border: "1px solid rgba(255,255,255,0.3)",
                      padding: "0.5rem 0.8rem",
                      gap: "1rem",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "20px", textAlign: "center" }}
                      >
                        Event Name: {rowData?.eventName}
                      </Typography>
                      <Typography
                        sx={{ fontSize: "17px", textAlign: "center" }}
                      >
                        Session: {rowData?.sessionName}
                      </Typography>
                      {positions?.[0]?.coordinator?.length > 0 && (
                        <Typography sx={{ fontSize: "14px", textWrap: "wrap" }}>
                          Coordinator
                          {positions?.[0]?.coordinator?.length > 1
                            ? "s"
                            : ""}:{" "}
                          {positions?.[0]?.coordinator
                            ?.map(
                              (item) =>
                                `${item?.fullName} - (${phoneNumberFormat(item?.mobile)})`,
                            )
                            .join(", ")}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    flex: "1",
                    gap: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {positions?.map((item, index) => {
                    const contractorStatus = getContractorStatus(
                      item?.contractors,
                    );
                    return (
                      <Accordion
                        key={index}
                        sx={{
                          borderRadius: "8px",
                          backgroundColor: "transparent",
                          width: "100%",
                        }}
                        expanded={expanded === `panel${index}`}
                        onChange={handleAccChange(`panel${index}`)}
                      >
                        <AccordionSummary
                          sx={{
                            backgroundColor: "rgba(100, 100, 100, 0.4)",
                            border: `1px solid ${getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            })}`,
                            borderRadius: "8px",
                            "& p": {
                              fontSize: "1.2rem",
                            },

                            "@media(max-width: 600px)": {
                              fontSize: "1rem",
                            },
                          }}
                          expandIcon={<ExpandMore sx={{ color: "white" }} />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "1rem",
                              }}
                            >
                              <Typography sx={{ color: "white" }}>
                                {item?.position?.positionName}
                              </Typography>
                              <Typography
                                sx={{
                                  display: isSmallScreen
                                    ? "none"
                                    : "inline-flex",
                                }}
                              >
                                {getUniversalDateTimeFormat({
                                  dateTime: item?.position?.startDate,
                                })}
                              </Typography>
                              <Typography
                                sx={{
                                  display: isSmallScreen
                                    ? "none"
                                    : "inline-flex",
                                }}
                              >
                                {dateRegex.test(
                                  item?.position?.timeIn?.split?.("T")?.[0],
                                )
                                  ? formatAMPM(
                                      convertFromUTCToGivenTimezone({
                                        dateStr: item?.position?.timeIn,
                                        timezone: item?.eventTimeZone,
                                      }),
                                    )
                                  : "TBD"}
                              </Typography>
                            </Box>

                            <Typography
                              sx={{
                                color: getTextColorOfStatus(contractorStatus),
                                border: `1px solid ${getColorOfStatus(contractorStatus)}`,
                                backgroundColor:
                                  getColorOfStatus(contractorStatus),
                                padding: "0.2rem",
                                borderRadius: "8px",
                                minWidth: "23%",
                                textAlign: "center",
                                // height: "35px",
                                height: "auto",
                                textTransform: "capitalize",
                              }}
                            >
                              {contractorStatus}
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            backgroundColor: "transparent",
                            border: `1px solid ${getCssVariableHandler({
                              variableName: "--primary-pink-hex",
                            })}`,
                            borderTop: "none",
                            borderRadius: "8px",
                            padding: "1rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            gap: "1rem",
                            flexDirection: "column",
                            overflowY: "auto",
                            maxHeight: "65%",
                            "& p": {
                              fontSize: "1.2rem",
                            },
                            "@media(max-width: 600px)": {
                              fontSize: "1rem",
                            },
                          }}
                          className="custom-scroll-design"
                        >
                          {item?.adminMessage && (
                            <Box
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                mt: "0.5rem",
                                px: "0.5rem",
                              }}
                            >
                              <Typography sx={{ fontSize: "14px" }}>
                                <span
                                  style={{
                                    color: getCssVariableHandler({
                                      variableName: "--primary-pink-hex",
                                    }),
                                  }}
                                >
                                  Admin Message:
                                </span>{" "}
                                {item?.adminMessage}
                              </Typography>
                            </Box>
                          )}
                          <Box
                            sx={{
                              border: `1px solid ${theme.palette.secondary.main}`,
                              width: "100%",
                              borderRadius: "3px",
                              height: "auto",
                              padding: "10px",
                              gap: "10px",
                              display: "flex",
                              flexDirection: "column",
                              fontSize: "14px",
                              zIndex: "10",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                zIndex: "10",
                                "& p": {
                                  width: "50%",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  margin: "0 auto",
                                }}
                              >
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  Date Start:{" "}
                                </span>
                                {getUniversalDateTimeFormat({
                                  dateTime: item?.position?.startDate,
                                })}
                              </Typography>

                              <Typography
                                sx={{
                                  margin: "0 auto",
                                }}
                              >
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  Overnight Shift:{" "}
                                </span>
                                {item?.position?.overNightShift ? "Yes" : "No"}
                              </Typography>
                            </Box>
                            <Divider
                              sx={{
                                width: "100%",
                                border: `1px solid ${theme.palette.secondary.main}`,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                zIndex: "10",
                                "& p": {
                                  width: "50%",
                                },
                              }}
                            >
                              <Typography>
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  {" "}
                                  Time In:{"  "}
                                </span>
                                {/* {data?.timeIn} */}
                                {dateRegex.test(
                                  item?.position?.timeIn?.split?.("T")?.[0],
                                )
                                  ? formatAMPM(
                                      convertFromUTCToGivenTimezone({
                                        dateStr: item?.position?.timeIn,
                                        timezone: item?.eventTimeZone,
                                      }),
                                    )
                                  : "TBD"}
                              </Typography>
                              <Typography
                                sx={{
                                  margin: "0 auto",
                                }}
                              >
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  Time End:{"  "}
                                </span>
                                {/* {data?.timeOut} */}
                                {dateRegex.test(
                                  item?.position?.timeOut?.split?.("T")?.[0],
                                )
                                  ? formatAMPM(
                                      convertFromUTCToGivenTimezone({
                                        dateStr: item?.position?.timeOut,
                                        timezone: item?.eventTimeZone,
                                      }),
                                    )
                                  : "TBD"}
                              </Typography>
                            </Box>
                            <Divider
                              sx={{
                                width: "100%",
                                border: `1px solid ${theme.palette.secondary.main}`,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                "& p": {
                                  width: "50%",
                                },
                              }}
                            >
                              <Typography>
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  Complexity:{"  "}
                                </span>
                                {item?.position?.complexity}
                              </Typography>
                              <Typography
                                sx={{
                                  margin: "0 28%",
                                }}
                              >
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  Attire:{"  "}
                                </span>
                                {item?.position?.attire}
                              </Typography>
                            </Box>
                            <Divider
                              sx={{
                                width: "100%",
                                border: `1px solid ${theme.palette.secondary.main}`,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography>
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  {" "}
                                  Meal Option:{"  "}
                                </span>
                                {item?.position?.lunchOption}
                              </Typography>
                            </Box>
                            <Divider
                              sx={{
                                width: "100%",
                                border: `1px solid ${theme.palette.secondary.main}`,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography>
                                <span
                                  style={{
                                    color: `${theme.palette.secondary.main}`,
                                  }}
                                >
                                  {" "}
                                  Comments:{"  "}
                                </span>
                                {item?.position?.comments}
                              </Typography>
                            </Box>
                          </Box>

                          {/* NOTE: buttons for request reimbursement */}
                          {showButtons &&
                            contractorStatus.toLowerCase() ===
                              "not responded" && (
                              <Box
                                sx={{
                                  width: "50%",
                                  height: "auto",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "10px",
                                  margin: "0 auto",
                                }}
                              >
                                <CustomButton
                                  onClick={() => {
                                    handleAcceptClick(
                                      item?.opportunityId,
                                      item?.positionId,
                                    );
                                  }}
                                >
                                  <Typography sx={{ fontSize: "1.5rem" }}>
                                    Accept
                                  </Typography>
                                </CustomButton>
                                <SecondaryButton
                                  onClick={() => {
                                    handleDeclineClick(
                                      item?.opportunityId,
                                      item?.positionId,
                                    );
                                  }}
                                >
                                  <Typography sx={{ fontSize: "1.5rem" }}>
                                    Decline
                                  </Typography>
                                </SecondaryButton>
                              </Box>
                            )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "1rem 1rem 1rem 3rem",
                    backgroundColor: "rgb(209, 117, 182)",
                    borderRadius: "0.2rem",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: "10",
                      color: "rgba(245,245,245,1) !important",
                      opacity: "0.5",
                    }}
                  >
                    {rowData?.location && (
                      <Typography sx={{ textAlign: "start" }}>
                        {rowData?.location}
                      </Typography>
                    )}
                    <Typography
                      sx={{ textAlign: "start" }}
                    >{` ${rowData?.venue}, ${rowData?.venueAddressLine1}, ${rowData?.venueCity}, ${rowData?.venueState}, ${rowData?.venueZipCode}`}</Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: "10",
                      height: "100px",
                    }}
                  >
                    <iframe
                      width="100%"
                      height="100%"
                      loading="lazy"
                      allowfullscreen
                      src={`https://www.google.com/maps/embed/v1/place?key=${import.meta.env.VITE_GOOGLE_API_KEY}${
                        rowData?.lat && rowData?.long
                          ? `&center=${rowData.lat},${rowData.long}`
                          : ""
                      }&q=${encodeURIComponent(
                        [
                          rowData?.venue,
                          rowData?.venueAddressLine1,
                          rowData?.venueCity,
                          rowData?.venueState,
                          rowData?.venueZipCode,
                        ]
                          .filter(Boolean) // Remove falsy values
                          .join(", "), // Combine valid parts with a comma and space
                      )}`}
                    />
                  </Box>
                </Box>
              </>
            ) : null}

            {showButtons && !isLoading && showBtns && (
              <Box
                sx={{
                  width: "50%",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  margin: "1rem auto",
                }}
              >
                <CustomButton onClick={handleAcceptMultipleOppClick}>
                  <Typography sx={{ fontSize: "1.2rem" }}>
                    {allNR ? "Accept All" : "Accept Rest"}
                  </Typography>
                </CustomButton>
                <SecondaryButton onClick={handleMultipleOppDeclineClick}>
                  <Typography sx={{ fontSize: "1.2rem" }}>
                    {allNR ? "Decline All" : "Decline Rest"}
                  </Typography>
                </SecondaryButton>
              </Box>
            )}
          </Box>
        )}

        {alertData?.status && (
          <AlertDialogForSendOpportunity
            open={alertData?.status}
            message={alertData?.message}
            title={alertData?.title}
            onOk={alertData?.onOk}
            okLabel={alertData?.okLabel}
            handleClose={() => setAlertData(initialAlertData)}
            isLoading={alertData?.isLoading || isLoading || loading}
          />
        )}
      </Box>
    </Modal>
  );
}

ViewMultipleOpportunityModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  showButtons: PropTypes.bool,
  rowData: PropTypes.object,
  setCount: PropTypes.func,
};